import { OpenPosState } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { postOpenPos } from './openPos.services';

export const initialState: OpenPosState = {
    data: {},
    status: "loading",
    error: {}
}

export const OpenPosSlice = createSlice({
    name: 'openPos',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postOpenPos.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(postOpenPos.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(postOpenPos.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const OpenPosReducer = OpenPosSlice.reducer